import type { BadgeProps } from '@shared/components';

export const PAYMENT_IN_PROGRESS_STATUS = 'payment_in_progress';
export const AWAITING_AGREEMENT_STATUS = 'awaiting_agreement';
export const AWAITING_ACTIVATION_STATUS = 'awaiting_activation';

export const AWAITING_AGREEMENT_REASON =
    'This quote is completed. Its agreement has not been created yet.';

interface StatusPresentation {
    label: string;
    variant: NonNullable<BadgeProps['variant']>;
}

// Only the states whose raw value does not read as English. `live`, `dead` and `active`
// keep the plain capitalised span the table has always rendered.
const PRE_ACTIVE_PRESENTATION: Readonly<Record<string, StatusPresentation>> = {
    [PAYMENT_IN_PROGRESS_STATUS]: { label: 'Live — payment in progress', variant: 'info' },
    [AWAITING_AGREEMENT_STATUS]: { label: 'Completed — awaiting agreement', variant: 'warning' },
    [AWAITING_ACTIVATION_STATUS]: { label: 'Completed — awaiting activation', variant: 'info' },
};

export const resolveStatusPresentation = (status?: string): StatusPresentation | null =>
    (status && PRE_ACTIVE_PRESENTATION[status]) || null;

export const statusFilterLabel = (status: string): string =>
    PRE_ACTIVE_PRESENTATION[status].label;
